<script>
// Имена роутов подразделов «Аналитики»: по ним раздел сам раскрывается,
// когда открыта любая из его страниц. В разделе только дашборды с графиками —
// отчётные формы и таблицы стоят отдельными пунктами.
const ANALYTICS_MENU = ['DiagramAnalytics', 'CustomsAnalytics', 'GearsAnalytics']
// То же для раздела «Обновления системы» в админке
const SYSTEM_UPDATES_MENU = ['SystemUpdatesAdmin', 'SystemUpdateCategories']

export default {
	name: 'MainSidebar',
	data: function () {
		return {
			menuClick: null,
			logClick: null,
			sidebarClick: false,
			integrationPanelClick: false,
			virtualWarehouseClick: null,
			// Единственный источник правды для раскрытия «Аналитики»: если seed-ить его
			// из :active на каждый пересчёт, свернуть раздел на его же странице не выйдет.
			analyticsClick: false,
			systemUpdatesClick: false,
		}
	},
	props: {
		active: {
			type: Array,
			default: function () {
				return []
			},
		},
	},
	computed: {
		isSalesman() {
			return this.$store.state.userObject?.role?.name === 'salesman'
		},
		// «ГО» — это go, go_manager и go_check: право `go_menu` засеяно ровно им.
		isGo() {
			return this.$store.getters.userPermission(['go_menu'])
		},
		childrenMenuActive: function () {
			return function (list) {
				if (this.active.length) {
					let childrenMenu = this.active.find((item) => {
						return list.find((listItem) => {
							return item == listItem ? true : false
						})
					})
					if (childrenMenu && this.menuClick == null) {
						this.menuClick = true
					}
				}
				return this.menuClick
			}
		},
		childrenLogActive: function () {
			return function (list) {
				if (this.active.length) {
					let childrenMenu = this.active.find((item) => {
						return list.find((listItem) => {
							return item == listItem ? true : false
						})
					})
					if (childrenMenu && this.logClick == null) {
						this.logClick = true
					}
				}
				return this.logClick
			}
		},
		childrenVirtualWarehouseActive: function () {
			return function (list) {
				if (this.active.length) {
					let childrenMenu = this.active.find((item) => {
						return list.find((listItem) => {
							return item == listItem ? true : false
						})
					})
					if (childrenMenu && this.virtualWarehouseClick == null) {
						this.virtualWarehouseClick = true
					}
				}
				return this.virtualWarehouseClick
			}
		},
		// В отличие от остальных разделов у «Аналитики» нет пункта-родителя, которым
		// страницы помечали бы себя в :active — узнаём её по именам самих подразделов,
		// чтобы не править :active на десятках готовых страниц.
		analyticsSectionActive: function () {
			return Boolean(this.active.find((item) => ANALYTICS_MENU.includes(item)))
		},
		// Раздел показываем, только если хотя бы один подраздел доступен, —
		// условия те же, что у пунктов внутри.
		hasAnalyticsSection: function () {
			const can = (list) => this.$store.getters.userPermission(list)

			return Boolean(
				can(['read_diagram_analytics']) ||
					can(['read_customs']) ||
					(this.isGo && can(['read_analytic'])),
			)
		},
		systemUpdatesSectionActive: function () {
			return Boolean(this.active.find((item) => SYSTEM_UPDATES_MENU.includes(item)))
		},
		hasSystemUpdatesSection: function () {
			return this.$store.getters.userPermission([
				'manage_system_updates',
				'manage_system_update_categories',
			])
		},
	},
	created() {
		// Открыта страница раздела — показываем его развёрнутым, дальше пункт живёт
		// на кликах пользователя.
		this.analyticsClick = this.analyticsSectionActive
		this.systemUpdatesClick = this.systemUpdatesSectionActive
	},
	methods: {
		menuActive(menu) {
			if (this.active.length) {
				return this.active.find((item) => {
					return item == menu ? true : false
				})
			}
			return false
		},
	},
}
</script>

<template>
	<div>
		<div class="main__sidebar" v-bind:class="{ 'main__sidebar--active': sidebarClick }">
			<div class="main__sidebar--burger">
				<a class="sidebar__burger" @click="sidebarClick = !sidebarClick">
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M3 9h12M3 4.5h12M3 13.5h12" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</a>
			</div>
			<nav class="main__sidebar--nav">
				<ul class="menu sidebar__nav sidebar__nav--main">
					<li class="sidebar-item" :class="{ 'menu-open': menuActive('Account') }">
						<router-link :to="'/' + $i18n.locale + '/account/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.949 9.12l8.64-6.72 8.64 6.72v10.56a1.92 1.92 0 01-1.92 1.92H4.868a1.92 1.92 0 01-1.92-1.92V9.12z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.709 21.6V12h5.76v9.6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('site.home_page') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['declarer_menu'])"
						:class="{ 'menu-open': menuActive('MyProfile') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/info'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M20.027 21.16v-2a4 4 0 00-4-4h-8a4 4 0 00-4 4v2M12.027 11.16a4 4 0 100-8 4 4 0 000 8z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('admin.login.my_profile') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_limit'])"
						:class="{ 'menu-open': menuActive('LimitManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/limits/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 8c4.97 0 9-1.343 9-3s-4.03-3-9-3-9 1.343-9 3 4.03 3 9 3zM21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.limit') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_quota'])"
						:class="{ 'menu-open': menuActive('QuotaManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/quotas/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 11l4-4-4-4M21 7H9M7 21l-4-4 4-4M15 17H3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.quotas') }}
						</router-link>
					</li>
					<!-- Старый раздел «Проектная мощность» скрыт — заменён на ЗПМ (см. ниже) -->
					<li
						v-if="false"
						class="sidebar-item"
						:class="{ 'menu-open': menuActive('DesignCapacity') }"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/design_capacity/'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 11l4-4-4-4M21 7H9M7 21l-4-4 4-4M15 17H3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.design_capacity') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_zpm'])"
						:class="{ 'menu-open': menuActive('Zpm') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/zpm/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 11l4-4-4-4M21 7H9M7 21l-4-4 4-4M15 17H3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.zpm') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_analytics-aqua'])"
						:class="{ 'menu-open': menuActive('AquaAnalytics') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/aqua-analytics'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 11l4-4-4-4M21 7H9M7 21l-4-4 4-4M15 17H3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.aqua_analytics') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="
							$store.getters.userPermission(['read_virtual_warehouse']) ||
							($store.state.userObject && $store.state.userObject.subject_kind === 'aquaculture')
						"
						:class="{ 'menu-open': menuActive('ZpmMy') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/zpm-my/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 11l4-4-4-4M21 7H9M7 21l-4-4 4-4M15 17H3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.zpm') }}
						</router-link>
					</li>
					<!-- <li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_quota-reverse'])"
						:class="{ 'menu-open': menuActive('QuotaReverseManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/quotas-reverse/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 11l4-4-4-4M21 7H9M7 21l-4-4 4-4M15 17H3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.quotas_reverse') }}
						</router-link>
					</li> -->

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_mastering'])"
						:class="{ 'menu-open': menuActive('MasteringManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/mastering/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.mastering') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_reserve_fund'])"
						:class="{ 'menu-open': menuActive('ReserveFundManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/reserve-fund/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.reserve_fund') }}
						</router-link>
					</li>

					<!-- <li
            class="sidebar-item"
            v-if="$store.getters.userPermission(['read_app_quota'])"
            :class="{ 'menu-open': menuActive('ApplicationQuotasManagement') }"
          >
            <a :href="'https://elicense.kz/?lang=ru'" class="sidebar-link" target="_blank">
              <i class="sidebar-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5 12h14M12 5l7 7-7 7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </i>
              {{ $t('sidebar.elicense_quotas') }}
            </a>
          </li> -->
					<!-- <li
            class="sidebar-item"
            v-if="$store.getters.userPermission(['read_permission_catch'])"
            :class="{ 'menu-open': menuActive('ApplicationPermissionsManagement') }"
          >
            <a :href="'https://elicense.kz/?lang=ru'" class="sidebar-link" target="_blank">
              <i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5 12h14M12 5l7 7-7 7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </i>
              {{ $t('sidebar.elicense_permission') }}
            </a>
          </li> -->

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_permission_catch'])"
						:class="{ 'menu-open': menuActive('ApplicationPermissionsManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/fishing-permit/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5 12h14M12 5l7 7-7 7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.elicense_permission') }}
						</router-link>
					</li>

					<li
						class="sidebar-item sidebar__item--children"
						v-if="
							$store.getters.userPermission([
								'read_trade',
								'read_grown',
								'read_purchased',
								'read_implemented',
							])
						"
						v-bind:class="{
							'menu-open': menuActive('TradeManagementMain') || logClick,
							'menu-open-arrow': logClick,
						}"
					>
						<a class="sidebar-link" @click="logClick = !logClick">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.magazines') }}
							<span class="sidebar-arrow">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 9l6 6 6-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</span>
						</a>
						<transition name="fade">
							<ul
								class="menu sidebar__nav sidebar__nav--treeview"
								v-if="childrenLogActive(['TradeManagementMain'])"
							>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_trade']) && !isSalesman"
									:class="{ 'menu-open': menuActive('TradeManagement') }"
								>
									<router-link :to="'/' + $i18n.locale + '/account/trade/'" class="sidebar-link">
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.magazines_trade') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_trade']) && !isSalesman"
									:class="{ 'menu-open': menuActive('MeliorationManagement') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/melioration/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.magazines_melioration') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_grown']) && !isSalesman"
									:class="{ 'menu-open': menuActive('GrownManagement') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/logs/grown/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.magazines_grown') }}
									</router-link>
								</li>
								<!-- <li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_purchased'])"
									:class="{ 'menu-open': menuActive('PurchasedManagement') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/logs/purchased/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.magazines_purchased') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_implemented'])"
									:class="{ 'menu-open': menuActive('ImplementedManagement') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/logs/implemented/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.magazines_implemented') }}
									</router-link>
								</li> -->
							</ul>
						</transition>
					</li>

					<li
						class="sidebar-item"
						v-if="
							$store.getters.userPermission([
								'read_trade',
								'read_grown',
								'read_purchased',
								'read_implemented',
							]) && !isSalesman
						"
						:class="{ 'menu-open': menuActive('Brigade') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/brigade/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 8c4.97 0 9-1.343 9-3s-4.03-3-9-3-9 1.343-9 3 4.03 3 9 3zM21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.brigade') }}
						</router-link>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['declarer_menu'])"
						:class="{ 'menu-open': menuActive('MyGears') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/gears/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.43 6.823c.423-.372.728-.64 1.4-.64V5c-1.118 0-1.707.519-2.181.936-.422.372-.727.64-1.4.64-.672 0-.977-.268-1.4-.64C17.376 5.519 16.786 5 15.67 5c-1.12 0-1.708.519-2.182.936-.422.372-.728.64-1.4.64-.671 0-.976-.268-1.399-.64C10.215 5.519 9.626 5 8.508 5s-1.708.52-2.18.936c-.423.372-.728.64-1.4.64-.672 0-.976-.268-1.399-.64C3.056 5.519 2.466 5 1.35 5v1.182c.671 0 .976.27 1.399.641.473.417 1.062.936 2.18.936s1.708-.519 2.18-.936c.423-.372.728-.64 1.4-.64.672 0 .977.268 1.399.64.473.417 1.063.936 2.181.936s1.708-.519 2.181-.936c.422-.372.727-.64 1.4-.64.672 0 .977.268 1.4.64.368.325.807.71 1.51.865v2.017c-.268-.113-.479-.296-.73-.516-.473-.417-1.062-.936-2.18-.936-1.119 0-1.708.52-2.181.936-.423.373-.728.641-1.4.641-.672 0-.977-.268-1.4-.64-.472-.418-1.062-.937-2.18-.937s-1.707.52-2.18.936c-.423.373-.728.641-1.4.641-.671 0-.976-.268-1.398-.64-.474-.418-1.063-.937-2.181-.937v1.183c.671 0 .977.269 1.399.64.473.418 1.062.937 2.18.937 1.119 0 1.708-.52 2.181-.936.422-.372.727-.641 1.4-.641.671 0 .976.269 1.398.64.474.418 1.063.937 2.181.937 1.119 0 1.708-.52 2.181-.936.423-.372.728-.641 1.4-.641.672 0 .977.269 1.4.64.368.325.807.71 1.51.865v4.514c0 .74-.602 1.343-1.343 1.343-.74 0-1.343-.602-1.343-1.342h-1.182a2.528 2.528 0 002.525 2.525 2.528 2.528 0 002.526-2.526v-4.483c.797-.13 1.274-.547 1.67-.895.422-.372.727-.641 1.4-.641V8.253c-1.12 0-1.709.52-2.182.936-.297.262-.539.47-.888.572V7.718c.796-.129 1.273-.546 1.668-.895z" stroke="#52A5FC"/><path d="M9.058 12.937c-2.022 0-4.183 1.559-5.06 2.267L1.97 13.458l-.772.897 1.89 1.626-1.89 1.626.772.897 2.029-1.746c.876.708 3.037 2.268 5.06 2.268 2.661 0 4.668-1.31 4.668-3.045 0-1.735-2.007-3.044-4.669-3.044v0zm0 4.906c-1.523 0-3.275-1.195-4.134-1.862.858-.668 2.607-1.862 4.134-1.862 2.154 0 3.486.967 3.486 1.862 0 .895-1.332 1.862-3.486 1.862v0z" stroke="#52A5FC"/><path d="M9.897 15.39h1.084v1.182H9.897V15.39z" stroke="#52A5FC" stroke-width=".5"/></svg>
							</i>
							{{ $t('sidebar.my_gears') }}
						</router-link>
					</li>

					<li
						class="sidebar-item sidebar__item--children"
						v-if="$store.getters.userPermission(['read_virtual_warehouse'])"
						:class="{
							'menu-open': menuActive('VirtualWarehouseMain') || virtualWarehouseClick,
							'menu-open-arrow': virtualWarehouseClick,
						}"
					>
						<a class="sidebar-link" @click="virtualWarehouseClick = !virtualWarehouseClick">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M3.17 7.44L12 12.55l8.77-5.08M12 21.61v-9.07" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.93 2.48L4.59 5.44c-1.21.67-2.2 2.35-2.2 3.73v5.65c0 1.38.99 3.06 2.2 3.73l5.34 2.97c1.14.63 3.01.63 4.15 0l5.34-2.97c1.21-.67 2.2-2.35 2.2-3.73V9.17c0-1.38-.99-3.06-2.2-3.73l-5.34-2.97c-1.15-.63-3.01-.63-4.15.01z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $i18n.locale === 'ru' ? 'Виртуальный склад' : 'Виртуалды қойма' }}
							<span class="sidebar-arrow">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 9l6 6 6-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</span>
						</a>
						<transition name="fade">
							<ul
								class="menu sidebar__nav sidebar__nav--treeview"
								v-if="childrenVirtualWarehouseActive(['VirtualWarehouseMain'])"
							>
								<li class="sidebar-item" :class="{ 'menu-open': menuActive('VirtualWarehouse') }">
									<router-link
										:to="'/' + $i18n.locale + '/account/virtual-warehouse/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2 9V7c0-3 2-5 5-5h10c3 0 5 2 5 5v2M2 15v2c0 3 2 5 5 5h10c3 0 5-2 5-5v-2" stroke="#0A091D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.7 9.26l5.3 3.07 5.26-3.05M12 17.77v-5.45" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.76 6.29l-3.2 1.78c-.72.4-1.32 1.41-1.32 2.24v3.39c0 .83.59 1.84 1.32 2.24l3.2 1.78c.68.38 1.8.38 2.49 0l3.2-1.78c.72-.4 1.32-1.41 1.32-2.24v-3.39c0-.83-.59-1.84-1.32-2.24l-3.2-1.78c-.69-.39-1.81-.39-2.49 0z" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.virtual_warehouse') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									:class="{ 'menu-open': menuActive('VirtualWarehouseHistory') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/virtual-warehouse/history'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22 15c0 3.87-3.13 7-7 7l1.05-1.75M2 9c0-3.87 3.13-7 7-7L7.95 3.75M13.7 4.45l3.98 2.3 3.94-2.29M17.68 10.82V6.74" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.74 2.21l-2.4 1.33c-.54.3-.99 1.06-.99 1.68v2.54c0 .62.44 1.38.99 1.68l2.4 1.33c.51.29 1.35.29 1.87 0l2.4-1.33c.54-.3.99-1.06.99-1.68V5.22c0-.62-.44-1.38-.99-1.68l-2.4-1.33c-.51-.28-1.35-.28-1.87 0zM2.35 15.45l3.97 2.3 3.95-2.29M6.32 21.82v-4.08" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.39 13.21l-2.4 1.33c-.54.3-.99 1.06-.99 1.68v2.54c0 .62.44 1.38.99 1.68l2.4 1.33c.51.29 1.35.29 1.87 0l2.4-1.33c.54-.3.99-1.06.99-1.68v-2.54c0-.62-.44-1.38-.99-1.68l-2.4-1.33c-.52-.28-1.36-.28-1.87 0z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.virtual_warehouse_history') }}
									</router-link>
								</li>
								<!-- <li
									class="sidebar-item"
									:class="{ 'menu-open': menuActive('VirtualWarehouseProcess') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/virtual-warehouse/process'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M3.17 7.44L12 12.55l8.77-5.08M12 21.61v-9.07" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.61 9.17v5.66c0 .05 0 .09-.01.14-.7-.61-1.6-.97-2.6-.97-.94 0-1.81.33-2.5.88A3.97 3.97 0 0015 18c0 .75.21 1.46.58 2.06.09.16.2.31.32.45l-1.83 1.01c-1.14.64-3 .64-4.14 0l-5.34-2.96c-1.21-.67-2.2-2.35-2.2-3.73V9.17c0-1.38.99-3.06 2.2-3.73l5.34-2.96c1.14-.64 3-.64 4.14 0l5.34 2.96c1.21.67 2.2 2.35 2.2 3.73z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M23 18c0 1.2-.53 2.27-1.36 3A4 4 0 0119 22c-2.21 0-4-1.79-4-4 0-1.26.58-2.39 1.5-3.12A3.999 3.999 0 0123 18z" stroke="#171717" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.25 16.75v1.5L18 19" stroke="#171717" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.virtual_warehouse_process') }}
									</router-link>
								</li> -->
							</ul>
						</transition>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_trade_all']) && !isSalesman"
						:class="{ 'menu-open': menuActive('TradeManagementSupervisor') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/trade-list/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 8c4.97 0 9-1.343 9-3s-4.03-3-9-3-9 1.343-9 3 4.03 3 9 3zM21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.trade_list') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_power'])"
						:class="{ 'menu-open': menuActive('PowerReservoirManagement') }"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/power-reservoir/'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><mask id="a" fill="#fff"><path d="M2.72 7.65c.196.057.384.138.56.24a4 4 0 004.1 0 2.6 2.6 0 012.56 0 4.15 4.15 0 004.12 0 2.6 2.6 0 012.56 0 4.25 4.25 0 002.08.56 3.88 3.88 0 002-.56c.176-.102.364-.183.56-.24a1 1 0 00-.56-1.92 4.45 4.45 0 00-1 .45 2.08 2.08 0 01-2.1 0 4.64 4.64 0 00-4.54 0 2.11 2.11 0 01-2.12 0 4.64 4.64 0 00-4.54 0 2.08 2.08 0 01-2.1 0 4.45 4.45 0 00-1-.45 1 1 0 10-.56 1.92h-.02zm18 8.08c-.35.108-.686.26-1 .45a2.08 2.08 0 01-2.1 0 4.64 4.64 0 00-4.54 0 2.11 2.11 0 01-2.12 0 4.64 4.64 0 00-4.54 0 2.08 2.08 0 01-2.1 0 4.448 4.448 0 00-1-.45.999.999 0 10-.56 1.92c.196.057.384.138.56.24a4 4 0 004.1 0 2.6 2.6 0 012.56 0 4.15 4.15 0 004.12 0 2.6 2.6 0 012.56 0 4.25 4.25 0 002.08.56 3.881 3.881 0 002-.56c.176-.102.364-.183.56-.24a1 1 0 00-.56-1.92h-.02zm0-5c-.35.108-.686.26-1 .45a2.08 2.08 0 01-2.1 0 4.64 4.64 0 00-4.54 0 2.11 2.11 0 01-2.12 0 4.64 4.64 0 00-4.54 0 2.08 2.08 0 01-2.1 0 4.448 4.448 0 00-1-.45.998.998 0 00-1.32.68 1 1 0 00.68 1.24c.196.057.384.138.56.24a4 4 0 004.1 0 2.6 2.6 0 012.56 0 4.15 4.15 0 004.12 0 2.6 2.6 0 012.56 0 4.25 4.25 0 002.08.56 3.881 3.881 0 002-.56c.176-.102.364-.183.56-.24a1 1 0 00-.56-1.92h.06z"/></mask><path d="M2.72 7.65c.196.057.384.138.56.24a4 4 0 004.1 0 2.6 2.6 0 012.56 0 4.15 4.15 0 004.12 0 2.6 2.6 0 012.56 0 4.25 4.25 0 002.08.56 3.88 3.88 0 002-.56c.176-.102.364-.183.56-.24a1 1 0 00-.56-1.92 4.45 4.45 0 00-1 .45 2.08 2.08 0 01-2.1 0 4.64 4.64 0 00-4.54 0 2.11 2.11 0 01-2.12 0 4.64 4.64 0 00-4.54 0 2.08 2.08 0 01-2.1 0 4.45 4.45 0 00-1-.45 1 1 0 10-.56 1.92h-.02zm18 8.08c-.35.108-.686.26-1 .45a2.08 2.08 0 01-2.1 0 4.64 4.64 0 00-4.54 0 2.11 2.11 0 01-2.12 0 4.64 4.64 0 00-4.54 0 2.08 2.08 0 01-2.1 0 4.448 4.448 0 00-1-.45.999.999 0 10-.56 1.92c.196.057.384.138.56.24a4 4 0 004.1 0 2.6 2.6 0 012.56 0 4.15 4.15 0 004.12 0 2.6 2.6 0 012.56 0 4.25 4.25 0 002.08.56 3.881 3.881 0 002-.56c.176-.102.364-.183.56-.24a1 1 0 00-.56-1.92h-.02zm0-5c-.35.108-.686.26-1 .45a2.08 2.08 0 01-2.1 0 4.64 4.64 0 00-4.54 0 2.11 2.11 0 01-2.12 0 4.64 4.64 0 00-4.54 0 2.08 2.08 0 01-2.1 0 4.448 4.448 0 00-1-.45.998.998 0 00-1.32.68 1 1 0 00.68 1.24c.196.057.384.138.56.24a4 4 0 004.1 0 2.6 2.6 0 012.56 0 4.15 4.15 0 004.12 0 2.6 2.6 0 012.56 0 4.25 4.25 0 002.08.56 3.881 3.881 0 002-.56c.176-.102.364-.183.56-.24a1 1 0 00-.56-1.92h.06z" stroke="#52A5FC" stroke-width="3" mask="url(#a)"/></svg>
							</i>
							{{ $t('sidebar.power_reservoir') }}
						</router-link>
					</li>
					<!-- <li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_fish_book'])"
						:class="{
							'menu-open': menuActive('FishBookManagement'),
							'sidebar-item--disabled': true,
						}"
					>
						<router-link :to="'/' + $i18n.locale + '/account/fish-book/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2v0z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.fish_book') }}
						</router-link>
					</li> -->

					<!--
          <li class="sidebar-item sidebar-item--disabled" v-if="$store.getters.userPermission(['go_menu'])">
            <router-link :to="'/'+ $i18n.locale +'/account/#/'" class="sidebar-link">
              <i class="sidebar-icon">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.86 11.784v.92a10 10 0 11-5.93-9.14" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.86 4.704l-10 10.01-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </i>
              Контроль оборота рыбы и рыбной продукции
            </router-link>
          </li>
          -->

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_subject_all'])"
						:class="{ 'menu-open': menuActive('SubjectsManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/subjects-list/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.43 6.823c.423-.372.728-.64 1.4-.64V5c-1.118 0-1.707.519-2.181.936-.422.372-.727.64-1.4.64-.672 0-.977-.268-1.4-.64C17.376 5.519 16.786 5 15.67 5c-1.12 0-1.708.519-2.182.936-.422.372-.728.64-1.4.64-.671 0-.976-.268-1.399-.64C10.215 5.519 9.626 5 8.508 5s-1.708.52-2.18.936c-.423.372-.728.64-1.4.64-.672 0-.976-.268-1.399-.64C3.056 5.519 2.466 5 1.35 5v1.182c.671 0 .976.27 1.399.641.473.417 1.062.936 2.18.936s1.708-.519 2.18-.936c.423-.372.728-.64 1.4-.64.672 0 .977.268 1.399.64.473.417 1.063.936 2.181.936s1.708-.519 2.181-.936c.422-.372.727-.64 1.4-.64.672 0 .977.268 1.4.64.368.325.807.71 1.51.865v2.017c-.268-.113-.479-.296-.73-.516-.473-.417-1.062-.936-2.18-.936-1.119 0-1.708.52-2.181.936-.423.373-.728.641-1.4.641-.672 0-.977-.268-1.4-.64-.472-.418-1.062-.937-2.18-.937s-1.707.52-2.18.936c-.423.373-.728.641-1.4.641-.671 0-.976-.268-1.398-.64-.474-.418-1.063-.937-2.181-.937v1.183c.671 0 .977.269 1.399.64.473.418 1.062.937 2.18.937 1.119 0 1.708-.52 2.181-.936.422-.372.727-.641 1.4-.641.671 0 .976.269 1.398.64.474.418 1.063.937 2.181.937 1.119 0 1.708-.52 2.181-.936.423-.372.728-.641 1.4-.641.672 0 .977.269 1.4.64.368.325.807.71 1.51.865v4.514c0 .74-.602 1.343-1.343 1.343-.74 0-1.343-.602-1.343-1.342h-1.182a2.528 2.528 0 002.525 2.525 2.528 2.528 0 002.526-2.526v-4.483c.797-.13 1.274-.547 1.67-.895.422-.372.727-.641 1.4-.641V8.253c-1.12 0-1.709.52-2.182.936-.297.262-.539.47-.888.572V7.718c.796-.129 1.273-.546 1.668-.895z" stroke="#52A5FC"/><path d="M9.058 12.937c-2.022 0-4.183 1.559-5.06 2.267L1.97 13.458l-.772.897 1.89 1.626-1.89 1.626.772.897 2.029-1.746c.876.708 3.037 2.268 5.06 2.268 2.661 0 4.668-1.31 4.668-3.045 0-1.735-2.007-3.044-4.669-3.044v0zm0 4.906c-1.523 0-3.275-1.195-4.134-1.862.858-.668 2.607-1.862 4.134-1.862 2.154 0 3.486.967 3.486 1.862 0 .895-1.332 1.862-3.486 1.862v0z" stroke="#52A5FC"/><path d="M9.897 15.39h1.084v1.182H9.897V15.39z" stroke="#52A5FC" stroke-width=".5"/></svg>
							</i>
							{{ $t('sidebar.subjects_list') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_document', 'read_document_all'])"
						:class="{ 'menu-open': menuActive('DocumentManagement') }"
					>
						<!-- , 'go_menu' -->
						<router-link :to="'/' + $i18n.locale + '/account/documents/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.documents') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_reporting'])"
						:class="{ 'menu-open': menuActive('ReportingManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/reporting/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.reporting') }}
						</router-link>
					</li>
					<!-- hidden temporary -->
					<!-- <li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_reporting_all'])"
						:class="{
							'menu-open': menuActive('ReportingManagementSupervisor'),
							'sidebar-item--disabled': true,
						}"
					>
						<router-link :to="'/' + $i18n.locale + '/account/reporting-list/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 3a3.6 3.6 0 00-3.05 1.68 3.6 3.6 0 00-.9-.1 3.6 3.6 0 00-2.42 1.06 3.6 3.6 0 00-.94 3.32A3.6 3.6 0 003 12a3.6 3.6 0 001.69 3.05 3.6 3.6 0 00.95 3.32 3.6 3.6 0 003.35.96A3.6 3.6 0 0012 21a3.6 3.6 0 003.04-1.67 3.6 3.6 0 004.3-4.3 3.6 3.6 0 00-.01-6.07 3.6 3.6 0 00-4.3-4.3A3.6 3.6 0 0012 3zM15 10l-4 4M9 12l2 2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.reporting_list') }}
						</router-link>
					</li> -->

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_contest'])"
						:class="{ 'menu-open': menuActive('ContestManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/contest/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M3 15l2 2 4-4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.contest') }}
						</router-link>
					</li>
					<!-- <li
            class="sidebar-item"
            v-if="$store.getters.userPermission(['create_permission'])"
            :class="{ 'menu-open': menuActive('PermissionCreateManagement') }"
          >
            <router-link
              :to="'/' + $i18n.locale + '/account/permission-list/'"
              class="sidebar-link"
            >
              <i class="sidebar-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </i>
              {{ $t('sidebar.elicense_permission') }}
            </router-link>
          </li> -->
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_permission'])"
						:class="{ 'menu-open': menuActive('PermissionManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/permission/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 3v8l3-3 3 3V3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.permission') }}
						</router-link>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_fine'])"
						:class="{ 'menu-open': menuActive('FineManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/fine/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0v0zM12 9v4M12 17h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.fine') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_fine'])"
						:class="{ 'menu-open': menuActive('PrescriptionManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/prescription/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0v0zM12 9v4M12 17h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.prescription') }}
						</router-link>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['spv_check'])"
						:class="{
							'menu-open': menuActive('SPVCheck'),
						}"
					>
						<router-link :to="'/' + $i18n.locale + '/account/spv-check/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M3 15l2 2 4-4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.spv_check') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_reference'])"
						:class="{ 'menu-open': menuActive('ReferenceLogManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/reference-log/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.reference_log') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_grown_all'])"
						:class="{ 'menu-open': menuActive('ReadGrownAllManagement1') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/read-grown-all/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.aqua_report') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="
							$store.getters.userPermission(['read_register_requests_aqua']) &&
							!$store.getters.userPermission(['change_user'])
						"
						:class="{ 'menu-open': menuActive('RequestRegistration') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/request_registration/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.request_registration') }}
						</router-link>
					</li>

					<li
						class="sidebar-item sidebar__item--children"
						v-if="$store.getters.userPermission(['read_user'])"
						v-bind:class="{
							'menu-open': menuActive('UserManagementMain') || menuClick,
							'menu-open-arrow': menuClick,
						}"
					>
						<a class="sidebar-link" @click="menuClick = !menuClick">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.users_parent') }}
							<span class="sidebar-arrow">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 9l6 6 6-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</span>
						</a>
						<transition name="fade">
							<ul
								class="menu sidebar__nav sidebar__nav--treeview"
								v-if="childrenMenuActive(['UserManagementMain'])"
							>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_user'])"
									:class="{ 'menu-open': menuActive('UserManagement') }"
								>
									<router-link :to="'/' + $i18n.locale + '/account/users/'" class="sidebar-link">
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.users') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['change_user'])"
									:class="{ 'menu-open': menuActive('RequestRegistration') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/request_registration/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.request_registration') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['change_user'])"
									:class="{ 'menu-open': menuActive('RequestRecovery') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/request_recovery/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.request_recovery') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_actionlogs'])"
									:class="{ 'menu-open': menuActive('UserMonitoring') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/monitoring/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 20V10M12 20V4M6 20v-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.monitoring-subjects') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_actionlogs'])"
									:class="{ 'menu-open': menuActive('UserMonitoringUser') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/monitoring-user/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 20V10M12 20V4M6 20v-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.monitoring-user') }}
									</router-link>
								</li>
							</ul>
						</transition>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_catalog'])"
						:class="{ 'menu-open': menuActive('ReferenceManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/hanbooks/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.references') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['change_role'])"
						:class="{ 'menu-open': menuActive('RoleManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/roles/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 22H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM16 2v2M8 2v2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 14a3 3 0 100-6 3 3 0 000 6zM17 18.5c-1.4-1-3.1-1.5-5-1.5s-3.6.6-5 1.5" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.roles') }}
						</router-link>
					</li>
					<li
						class="sidebar-item sidebar__item--children"
						v-if="$store.getters.userPermission(['change_role'])"
						:class="{
							'menu-open': menuActive('IntegrationPanel') || integrationPanelClick,
							'menu-open-arrow': integrationPanelClick,
						}"
					>
						<a class="sidebar-link" @click="integrationPanelClick = !integrationPanelClick">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.integration_panel') }}
							<span class="sidebar-arrow">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 9l6 6 6-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</span>
						</a>
						<transition name="fade">
							<ul class="menu sidebar__nav sidebar__nav--treeview" v-if="integrationPanelClick">
								<li class="sidebar-item" :class="{ 'menu-open': menuActive('EASUCheck') }">
									<router-link
										:to="'/' + $i18n.locale + '/account/integration/easu-check'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.easu_check') }}
									</router-link>
								</li>
								<!-- <li class="sidebar-item" :class="{ 'menu-open': menuActive('CustomsInfo') }">
									<router-link
										:to="'/' + $i18n.locale + '/account/integration/customs-info'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.customs_info') }}
									</router-link>
								</li> -->
							</ul>
						</transition>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['create_news'])"
						:class="{ 'menu-open': menuActive('news') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/news/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.news') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['create_video'])"
						:class="{ 'menu-open': menuActive('Video') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/video/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.video') }}
						</router-link>
					</li>
					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['edit_contacts'])"
						:class="{ 'menu-open': menuActive('Contacts') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/contacts/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.contacts') }}
						</router-link>
					</li>

					<li
						v-if="$store.getters.userPermission(['read_monitoring'])"
						:class="{ 'menu-open': menuActive('MonitoringPage') }"
						class="sidebar-item"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/monitoring-subjects'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.monitoring-subjects') }}
						</router-link>
					</li>

					<!--
						Отчётные формы и таблицы стоят снаружи раздела «Аналитика»: графиков там
						нет — это вложенные таблицы, хаб ссылок на формы 1-ПХ…10-ПХ, реестр
						отчётов и форма 1-ПХ с выгрузкой в xls.
					-->
					<li
						v-if="$store.getters.userPermission(['read_analytic_trade']) && !isSalesman"
						:class="{ 'menu-open': menuActive('AnalyticManagement') }"
						class="sidebar-item"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/logs-analytics/fishing-log'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.analytics') }}
						</router-link>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['change_user']) && !isSalesman"
						:class="{ 'menu-open': menuActive('ReportingAnalyticManagement') }"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/reporting-analytics/1/region/admin'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.incorrect_trades') }}
						</router-link>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_reporting_all'])"
						:class="{ 'menu-open': menuActive('ReportingAnalyticManagement') }"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/reporting-analytics'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.reporting_analytics') }}
						</router-link>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['change_role'])"
						:class="{ 'menu-open': menuActive('ReportAnalyticsManagement') }"
					>
						<router-link
							:to="'/' + $i18n.locale + '/account/report-analytics'"
							class="sidebar-link"
						>
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.report_analytics') }}
						</router-link>
					</li>

					<li
						class="sidebar-item sidebar__item--children"
						v-if="hasAnalyticsSection"
						:class="{
							'menu-open': analyticsSectionActive || analyticsClick,
							'menu-open-arrow': analyticsClick,
						}"
					>
						<a class="sidebar-link" @click="analyticsClick = !analyticsClick">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.analytics_section') }}
							<span class="sidebar-arrow">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 9l6 6 6-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</span>
						</a>
						<transition name="fade">
							<ul class="menu sidebar__nav sidebar__nav--treeview" v-if="analyticsClick">
								<!--
									Дашборд считает по всей стране, поэтому он только для ГО. Одного
									`read_analytic` мало: миграция засеяла его и роли `declarer`,
									а `go_menu` есть ровно у go / go_manager / go_check.
								-->
								<li
									class="sidebar-item"
									v-if="isGo && $store.getters.userPermission(['read_analytic'])"
									:class="{ 'menu-open': menuActive('GearsAnalytics') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/gears-analytics/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.43 6.823c.423-.372.728-.64 1.4-.64V5c-1.118 0-1.707.519-2.181.936-.422.372-.727.64-1.4.64-.672 0-.977-.268-1.4-.64C17.376 5.519 16.786 5 15.67 5c-1.12 0-1.708.519-2.182.936-.422.372-.728.64-1.4.64-.671 0-.976-.268-1.399-.64C10.215 5.519 9.626 5 8.508 5s-1.708.52-2.18.936c-.423.372-.728.64-1.4.64-.672 0-.976-.268-1.399-.64C3.056 5.519 2.466 5 1.35 5v1.182c.671 0 .976.27 1.399.641.473.417 1.062.936 2.18.936s1.708-.519 2.18-.936c.423-.372.728-.64 1.4-.64.672 0 .977.268 1.399.64.473.417 1.063.936 2.181.936s1.708-.519 2.181-.936c.422-.372.727-.64 1.4-.64.672 0 .977.268 1.4.64.368.325.807.71 1.51.865v2.017c-.268-.113-.479-.296-.73-.516-.473-.417-1.062-.936-2.18-.936-1.119 0-1.708.52-2.181.936-.423.373-.728.641-1.4.641-.672 0-.977-.268-1.4-.64-.472-.418-1.062-.937-2.18-.937s-1.707.52-2.18.936c-.423.373-.728.641-1.4.641-.671 0-.976-.268-1.398-.64-.474-.418-1.063-.937-2.181-.937v1.183c.671 0 .977.269 1.399.64.473.418 1.062.937 2.18.937 1.119 0 1.708-.52 2.181-.936.422-.372.727-.641 1.4-.641.671 0 .976.269 1.398.64.474.418 1.063.937 2.181.937 1.119 0 1.708-.52 2.181-.936.423-.372.728-.641 1.4-.641.672 0 .977.269 1.4.64.368.325.807.71 1.51.865v4.514c0 .74-.602 1.343-1.343 1.343-.74 0-1.343-.602-1.343-1.342h-1.182a2.528 2.528 0 002.525 2.525 2.528 2.528 0 002.526-2.526v-4.483c.797-.13 1.274-.547 1.67-.895.422-.372.727-.641 1.4-.641V8.253c-1.12 0-1.709.52-2.182.936-.297.262-.539.47-.888.572V7.718c.796-.129 1.273-.546 1.668-.895z" stroke="#52A5FC"/><path d="M9.058 12.937c-2.022 0-4.183 1.559-5.06 2.267L1.97 13.458l-.772.897 1.89 1.626-1.89 1.626.772.897 2.029-1.746c.876.708 3.037 2.268 5.06 2.268 2.661 0 4.668-1.31 4.668-3.045 0-1.735-2.007-3.044-4.669-3.044v0zm0 4.906c-1.523 0-3.275-1.195-4.134-1.862.858-.668 2.607-1.862 4.134-1.862 2.154 0 3.486.967 3.486 1.862 0 .895-1.332 1.862-3.486 1.862v0z" stroke="#52A5FC"/><path d="M9.897 15.39h1.084v1.182H9.897V15.39z" stroke="#52A5FC" stroke-width=".5"/></svg>
										</i>
										{{ $t('sidebar.gears_analytics') }}
									</router-link>
								</li>

								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_diagram_analytics'])"
									:class="{ 'menu-open': menuActive('DiagramAnalytics') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/diagram-analytics/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.diagram_analytics') }}
									</router-link>
								</li>

								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['read_customs'])"
									:class="{ 'menu-open': menuActive('CustomsAnalytics') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/customs-analytics/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.customs_analytics_page') }}
									</router-link>
								</li>
							</ul>
						</transition>
					</li>

					<li
						class="sidebar-item"
						v-if="$store.getters.userPermission(['read_customs'])"
						:class="{ 'menu-open': menuActive('CustomsManagement') }"
					>
						<router-link :to="'/' + $i18n.locale + '/account/customs/'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1v0zM12 11h4M12 16h4M8 11h.01M8 16h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.customs_page') }}
						</router-link>
					</li>

					<li
						class="sidebar-item sidebar__item--children"
						v-if="hasSystemUpdatesSection"
						:class="{
							'menu-open': systemUpdatesSectionActive || systemUpdatesClick,
							'menu-open-arrow': systemUpdatesClick,
						}"
					>
						<a class="sidebar-link" @click="systemUpdatesClick = !systemUpdatesClick">
							<i class="sidebar-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.system_updates_admin') }}
							<span class="sidebar-arrow">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 9l6 6 6-6" stroke="#0A091D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</span>
						</a>
						<transition name="fade">
							<ul class="menu sidebar__nav sidebar__nav--treeview" v-if="systemUpdatesClick">
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['manage_system_updates'])"
									:class="{ 'menu-open': menuActive('SystemUpdatesAdmin') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/system-updates/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.system_updates_list') }}
									</router-link>
								</li>
								<li
									class="sidebar-item"
									v-if="$store.getters.userPermission(['manage_system_update_categories'])"
									:class="{ 'menu-open': menuActive('SystemUpdateCategories') }"
								>
									<router-link
										:to="'/' + $i18n.locale + '/account/system-update-categories/'"
										class="sidebar-link"
									>
										<i class="sidebar-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M2 15h10M9 18l3-3-3-3" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</i>
										{{ $t('sidebar.system_update_categories_short') }}
									</router-link>
								</li>
							</ul>
						</transition>
					</li>
					<!-- Публичная страница «Обновления системы» — для всех пользователей -->
					<li class="sidebar-item">
						<router-link :to="'/' + $i18n.locale + '/updates'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('sidebar.system_updates') }}
						</router-link>
					</li>
					<li class="sidebar-item" :class="{ 'menu-open': menuActive('Notifications') }">
						<router-link :to="'/' + $i18n.locale + '/account/notifications'" class="sidebar-link">
							<i class="sidebar-icon">
								<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.094 22.846c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zM12.094 8.846v4M12.094 16.846h.01" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
							</i>
							{{ $t('notification.title') }}
						</router-link>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>
